module.exports = __webpack_public_path__ + "img/recover-success-v2.1a894eee.png";